import styled from "styled-components";

import { GrayColors } from "@smartsuite/types";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 15px;
  background-color: ${GrayColors["G-0"]};
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 8px;
  word-break: break-word;
`;
